(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.TriplexManualCalloutsV1 = api;
    api.bootstrap(root.document, root.fetch);
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var VERSION = '2026-07-19.1';
  var EXACT_FIELDS = [
    'publication', 'revision', 'series', 'model', 'figureId',
    'partsListId', 'item', 'sku', 'variantContext.wing',
    'variantContext.material', 'variantContext.clearanceFinish'
  ];
  var EXPECTED_SKUS = ['102175+', '102232+', '117129+'];
  var hasOwn = function (object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  };
  var isObject = function (value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  };
  var nonEmptyString = function (value) {
    return typeof value === 'string' && value.length > 0;
  };
  var positiveInteger = function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && value > 0;
  };

  function validSource(source) {
    return isObject(source) &&
      nonEmptyString(source.publication) && nonEmptyString(source.revision) &&
      nonEmptyString(source.series) && nonEmptyString(source.figureId) &&
      nonEmptyString(source.partsListId) && positiveInteger(source.explodedViewPage) &&
      positiveInteger(source.partsTablePage) && Array.isArray(source.sourceIds) &&
      source.sourceIds.length > 0 && source.sourceIds.every(nonEmptyString);
  }

  function validRecord(sku, record) {
    return nonEmptyString(sku) && isObject(record) &&
      Array.isArray(record.models) && record.models.length > 0 && record.models.every(nonEmptyString) &&
      nonEmptyString(record.modelGroup) && nonEmptyString(record.item) &&
      nonEmptyString(record.description) && positiveInteger(record.qty) &&
      nonEmptyString(record.uom) && nonEmptyString(record.recordId) &&
      isObject(record.variantContext) &&
      nonEmptyString(record.variantContext.wing) &&
      nonEmptyString(record.variantContext.material) &&
      record.variantContext.clearanceFinish === 'standard' &&
      (!hasOwn(record, 'notes') || (Array.isArray(record.notes) && record.notes.every(nonEmptyString)));
  }

  function validCatalog(payload) {
    if (!isObject(payload) || payload.version !== VERSION || payload.failClosed !== true) return false;
    if (!Array.isArray(payload.exactMatchFields) || payload.exactMatchFields.length !== EXACT_FIELDS.length) return false;
    for (var i = 0; i < EXACT_FIELDS.length; i += 1) {
      if (payload.exactMatchFields[i] !== EXACT_FIELDS[i]) return false;
    }
    if (!validSource(payload.source) || !isObject(payload.recordsBySku)) return false;
    var skus = Object.keys(payload.recordsBySku).sort();
    if (skus.length !== EXPECTED_SKUS.length) return false;
    for (var expectedIndex = 0; expectedIndex < EXPECTED_SKUS.length; expectedIndex += 1) {
      if (skus[expectedIndex] !== EXPECTED_SKUS[expectedIndex]) return false;
    }
    for (var j = 0; j < skus.length; j += 1) {
      if (!validRecord(skus[j], payload.recordsBySku[skus[j]])) return false;
    }
    return true;
  }

  function resolve(payload, sku) {
    if (!validCatalog(payload) || !nonEmptyString(sku) || !hasOwn(payload.recordsBySku, sku)) return null;
    return {
      version: payload.version,
      sku: sku,
      source: payload.source,
      record: payload.recordsBySku[sku]
    };
  }

  function displayValue(value) {
    if (value === 'twin') return 'Twin wing';
    if (value === 'single') return 'Single wing';
    if (value === 'standard') return 'Standard clearance / finish';
    return value;
  }

  function createFact(documentRef, label, value) {
    var item = documentRef.createElement('div');
    var term = documentRef.createElement('dt');
    var detail = documentRef.createElement('dd');
    term.textContent = label;
    detail.textContent = value;
    item.appendChild(term);
    item.appendChild(detail);
    return item;
  }

  function render(container, match) {
    var documentRef = container.ownerDocument;
    var source = match.source;
    var record = match.record;
    var heading = documentRef.createElement('h2');
    var intro = documentRef.createElement('p');
    var facts = documentRef.createElement('dl');
    var variant = record.variantContext;

    container.textContent = '';
    heading.className = 'tx-manual-callout__title';
    heading.textContent = 'Verified manual callout';
    intro.className = 'tx-manual-callout__intro';
    intro.textContent = record.description + ' — exact OEM SKU ' + match.sku;
    facts.className = 'tx-manual-callout__facts';
    facts.appendChild(createFact(documentRef, 'Manual', source.publication));
    facts.appendChild(createFact(documentRef, 'Revision', source.revision));
    facts.appendChild(createFact(documentRef, 'Equipment', source.series + ' · ' + record.modelGroup));
    facts.appendChild(createFact(documentRef, 'Drawing', source.figureId));
    facts.appendChild(createFact(documentRef, 'Parts list', source.partsListId));
    facts.appendChild(createFact(documentRef, 'Pages', 'Exploded view ' + source.explodedViewPage + ' · Parts table ' + source.partsTablePage));
    facts.appendChild(createFact(documentRef, 'Item number', record.item));
    facts.appendChild(createFact(documentRef, 'Quantity', record.qty + ' ' + record.uom));
    facts.appendChild(createFact(documentRef, 'Variant context', displayValue(variant.wing) + ' · ' + displayValue(variant.material) + ' · ' + displayValue(variant.clearanceFinish)));
    container.appendChild(heading);
    container.appendChild(intro);
    container.appendChild(facts);
    container.hidden = false;
  }

  function selectedSku(container, product) {
    var section = container.closest ? container.closest('.tx-product-page') : null;
    var select = section && section.querySelector ? section.querySelector('select[name="id"]') : null;
    if (!select) return container.getAttribute('data-initial-sku') || '';
    var selectedId = String(select.value || '');
    var matches = (product.variants || []).filter(function (variant) {
      return String(variant.id) === selectedId;
    });
    return matches.length === 1 && typeof matches[0].sku === 'string' ? matches[0].sku : '';
  }

  function bootstrap(documentRef, fetchRef) {
    var containers = Array.prototype.slice.call(documentRef.querySelectorAll('[data-manual-callout-v1]'));
    containers.forEach(function (container) {
      var section = container.closest ? container.closest('.tx-product-page') : null;
      var productNode = section && section.querySelector ? section.querySelector('[id^="ProductJson-"]') : null;
      var assetUrl = container.getAttribute('data-catalog-url');
      if (!section || !productNode || !assetUrl || typeof fetchRef !== 'function') return;

      var product;
      try { product = JSON.parse(productNode.textContent); } catch (error) { return; }

      fetchRef(assetUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('manual-callout catalog unavailable');
          return response.json();
        })
        .then(function (payload) {
          if (!validCatalog(payload)) return;
          var update = function () {
            var match = resolve(payload, selectedSku(container, product));
            container.hidden = true;
            container.textContent = '';
            if (match) render(container, match);
          };
          var select = section.querySelector('select[name="id"]');
          if (select) select.addEventListener('change', update);
          update();
        })
        .catch(function () {
          container.hidden = true;
          container.textContent = '';
        });
    });
  }

  return {
    VERSION: VERSION,
    EXACT_FIELDS: EXACT_FIELDS.slice(),
    EXPECTED_SKUS: EXPECTED_SKUS.slice(),
    validCatalog: validCatalog,
    resolve: resolve,
    displayValue: displayValue,
    render: render,
    bootstrap: bootstrap
  };
}));
